




















































































































































































































































































































































































































































































import Vue from 'vue';
import printHeader from './PrintHeader.vue';
import printFooter from './PrintFooter.vue';
import { DialogViewModel, Prestazione } from '../../types';
import * as exportService from '@/services/common/export-service';

export default Vue.extend({
    components: { printHeader, printFooter },
    props: {
        item: { required: true },
        show: { default: false },
    },
    data(): DialogViewModel {
        return {
            isOpen: false,
        };
    },
    methods: {
        close() {
            this.isOpen = false;
            this.$emit('close');
        },
        print() {
            if (!this.item) {
                return;
            }
            exportService.exportToPDF(
                document.getElementById('prestazionePrint') as HTMLElement,
                {
                    fileName: (this.item as Prestazione).displayName,
                    margin: { left: 20, top: 20, right: 20 },
                    paperSize: 'A4',
                    scale: 0.5,
                }
            );
        },
    },
    watch: {
        show: {
            handler: function (val) {
                this.isOpen = val;
            },
        },
    },
});
